module.exports = __webpack_public_path__ + "static/media/career.c8df1340.jpg";